import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostExport } from "../../api/api";

type ExportCSVResult = {
  status: string;
  msg: string;
};

type ExportCSVInput = {
  siteName: string;
  dglist?: string[];
  serials?: string[];
};

export const useExportCSV = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      siteName,
      dglist,
      token,
      serials,
    }: ExportCSVInput & {
      token: string;
    }): Promise<ExportCSVResult> =>
      PostExport(token, {
        siteName,
        dglist,
        serials,
      }),

    onSuccess: (data) => {
      console.log("data", data);
    },

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { siteName, dglist, serials }: ExportCSVInput,
      options?: {
        onSuccess?: (data: ExportCSVResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          siteName,
          serials: [],
          dglist: dglist || [],
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
